import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=38e33be8&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./LoadingIcon.vue?vue&type=style&index=0&id=38e33be8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "38e33be8",
  null
  ,true
)

export default component.exports